import React from 'react';
import Grid2 from '@mui/material/Grid2';

export default React.memo(Grid2); ;
